import styled from 'styled-components'

export const DateRangeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  justify-content: center;
`

export const InputsDateRangeContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  justify-content: center;
`
